export type BankAccountFailureKind =
  | "duplicate"
  | "name_mismatch_plaid"
  | "name_mismatch_manual"
  | "capacity_mismatch"
  | "statement_older_than_3_months"
  | "joint_holder_kyc_failed"
  | "expired";

/** The fixed sentences Ops pick in Nucleus when they fail an account. */
const FAILURE_KIND_BY_REASON = new Map<string, BankAccountFailureKind>(
  Object.entries({
    "a duplicate bank account": "duplicate",
    "a name mismatch": "name_mismatch_plaid",
    "a name on the bank statement that does not match your profile":
      "name_mismatch_manual",
    "the account belonging to a different owner from the one it was added for":
      "capacity_mismatch",
    "a bank statement older than 3 months": "statement_older_than_3_months",
    "a failed KYC check on the external account holder":
      "joint_holder_kyc_failed",
    inactivity: "expired",
  } satisfies Record<string, BankAccountFailureKind>)
);

export const getBankAccountFailureKind = (
  failureReason?: string | null
): BankAccountFailureKind | null =>
  FAILURE_KIND_BY_REASON.get(failureReason?.trim() ?? "") ?? null;
